export const Layout = {
	chat: 'chat',
	createChat: 'createChat',
	updateChat: 'updateChat',
	createFolder: 'createFolder',
	updateFolder: 'updateFolder',
	copyCollab: 'copyCollab',
	channel: 'channel',
	notification: 'notification',
	openlines: 'openlines',
	openlinesV2: 'openlinesV2',
	conference: 'conference',
	settings: 'settings',
	copilot: 'copilot',
	collab: 'collab',
	vibecodeApp: 'vibecodeApp',
	market: 'market',
	taskComments: 'tasksTask',
	folder: 'folder',
};

export type LayoutType = $Values<typeof Layout>;
